module.exports = Promise.all([parcelRequire.load("6GakI"), parcelRequire.load("3ILOR"), parcelRequire.load("cCW1W")]).then(() => parcelRequire('1x7Mg'));